<div class="preloader">
  <div class="loader"></div>
  <img class="img-cloud" src="assets/images/icons/icon-cloud.svg" alt="">
  <div class="curtain"></div>
</div>